import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import {
  APP_EMAIL_SEQUENCES,
  APP_EMAIL_SEQUENCE_DETAIL,
  APP_MANAGE_EMAIL_SEQUENCE,
  APP_UPCOMING_SEQUENCE_STEPS,
} from "./emailSequences.constants";
import {
  APP_SEQUENCE_CONTACT_LIST_DETAIL,
} from "./contactLists/contactLists.labels";

const SequenceList = Loadable(
  lazy(() =>
    import("./SequenceList").then(({ SequenceList }) => ({
      default: SequenceList,
    }))
  )
);
const ContactListDetail = Loadable(
  lazy(() =>
    import("./contactLists/ContactListDetail").then(({ ContactListDetail }) => ({
      default: ContactListDetail,
    }))
  )
);
const ManageSequence = Loadable(
  lazy(() =>
    import("./ManageSequence/ManageSequence").then(({ ManageSequence }) => ({
      default: ManageSequence,
    }))
  )
);
const SequenceDetail = Loadable(
  lazy(() =>
    import("./SequenceDetail/SequenceDetail").then(({ SequenceDetail }) => ({
      default: SequenceDetail,
    }))
  )
);
const UpcomingSequenceSteps = Loadable(
  lazy(() =>
    import("./UpcomingSequenceSteps").then(({ UpcomingSequenceSteps }) => ({
      default: UpcomingSequenceSteps,
    }))
  )
);

export const emailSequencesRoutes = [
  {
    path: `${APP_EMAIL_SEQUENCES}`,
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <SequenceList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_SEQUENCE_CONTACT_LIST_DETAIL}/:listCode`,
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <ContactListDetail />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_MANAGE_EMAIL_SEQUENCE}`,
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <ManageSequence />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_MANAGE_EMAIL_SEQUENCE}/:sequenceCode`,
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <ManageSequence />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_EMAIL_SEQUENCE_DETAIL}/:sequenceCode`,
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <SequenceDetail />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_UPCOMING_SEQUENCE_STEPS}`,
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <UpcomingSequenceSteps />
      </AuthorizedRoute>
    ),
  },
];
